import { useEffect } from "react";
import { useAppDispatch } from "../../../hooks/useRedux";
import { useLocation } from "react-router-dom";
import {
  setOpenAuthSidebar,
  setOpenDriverSidebar,
  setOpenOwnerSidebar,
} from "../../../redux/features/settingSlice";

export default function NotFound() {
  const dispatch = useAppDispatch();

  const { pathname } = useLocation();

  useEffect(() => {
    dispatch(setOpenAuthSidebar(false));
    dispatch(setOpenDriverSidebar(false));
    dispatch(setOpenOwnerSidebar(false));
  }, [pathname]);
  return (
    <div
      style={{
        textAlign: "center",
        backgroundColor: "white",
      }}
    >
      Page Not Found
    </div>
  );
}
